module.exports = __webpack_public_path__ + "static/media/sample_certificate_image_female.66b83d8b.png";